module.exports = __webpack_public_path__ + "img/screenshot.48b5bec3.png";